import React, { Component } from 'react';
import { formatDate } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

class AdminStrikeAppeals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appeals: [],
      expandedId: null,
      loading: true,
      denyResponseText: '',
    };
    this.fetchAppeals = this.fetchAppeals.bind(this);
  }

  componentDidMount() {
    this.fetchAppeals();
  }

  componentDidUpdate(prevProps) {
    if (this.props.refreshKey !== prevProps.refreshKey) {
      this.fetchAppeals();
    }
  }

  fetchAppeals() {
    var self = this;
    self.setState({ loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/strike-appeals')
      .then(function(data) { self.setState({ appeals: data.appeals || [], loading: false }); })
      .catch(function(err) { console.log('Failed to fetch strike appeals:', err); self.setState({ loading: false }); });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var appeals = this.state.appeals;

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <div className="tw-text-center">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
            <span className="tw-text-sm tw-text-[#999]">Loading...</span>
          </div>
        </div>
      );
    }

    if (appeals.length === 0) {
      return (
        <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-w-16 tw-h-16 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#ECFDF5' }}>
            <i className="fa fa-check tw-text-2xl" style={{ color: '#10B981' }} />
          </div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">No Pending Appeals</h3>
          <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-1">All clear — no strike appeals to review</p>
        </div>
      );
    }

    return (
      <div className="tw-space-y-3">
        <div className="tw-px-1 tw-mb-2">
          <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">{appeals.length} pending appeal{appeals.length !== 1 ? 's' : ''}</span>
        </div>
        {appeals.map(function(appeal) {
          var expandKey = appeal.userId + '_' + appeal.strikeId;
          var isExpanded = self.state.expandedId === expandKey;
          var statusColor = appeal.userStatus === 'active' ? '#10B981' : appeal.userStatus === 'suspended' ? '#F59E0B' : appeal.userStatus === 'banned' ? '#EF4444' : '#6B7280';
          var statusBg = appeal.userStatus === 'active' ? '#ECFDF5' : appeal.userStatus === 'suspended' ? '#FEF3C7' : appeal.userStatus === 'banned' ? '#FEE2E2' : '#F3F4F6';

          return (
            <div key={expandKey} className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
              <div className="tw-p-4">
                <div className="tw-flex tw-gap-4">
                  {appeal.profilePic ? (
                    <img src={appeal.profilePic} alt="" className="tw-w-12 tw-h-12 tw-object-cover tw-rounded-full tw-flex-shrink-0" />
                  ) : (
                    <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                      <i className="fa fa-user tw-text-[#ccc]" />
                    </div>
                  )}
                  <div className="tw-flex-1 tw-min-w-0">
                    <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
                      <div>
                        <span
                          className="tw-text-sm tw-font-semibold tw-cursor-pointer hover:tw-underline"
                          style={{ color: '#D4A843' }}
                          onClick={function(e) { e.stopPropagation(); self.props.onOpenUserModal(appeal.userId); }}
                        >
                          {appeal.userName || 'Unknown'}
                        </span>
                        <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-0.5">
                          {appeal.email || ''}
                          <span className="tw-ml-2 tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium" style={{ backgroundColor: statusBg, color: statusColor }}>
                            {appeal.userStatus || 'active'}
                          </span>
                        </p>
                      </div>
                      <span className="tw-text-xs tw-px-2.5 tw-py-1 tw-rounded-full tw-font-bold tw-flex-shrink-0" style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}>
                        <i className="fa fa-clock-o tw-mr-1" />Pending
                      </span>
                    </div>
                    <div className="tw-mt-2">
                      <p className="tw-text-xs tw-text-[#999] tw-m-0">
                        <strong className="tw-text-[#666] dark:tw-text-[#bbb]">Strike:</strong> {appeal.strikeReason}
                        <span className="tw-mx-2">|</span>
                        <strong className="tw-text-[#666] dark:tw-text-[#bbb]">Appealed:</strong> {appeal.appealedAt ? formatDate(appeal.appealedAt) : ''}
                      </p>
                    </div>
                    <div className="tw-mt-3 tw-flex tw-flex-wrap tw-gap-2">
                      <button
                        className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]"
                        onClick={function() { self.setState({ expandedId: isExpanded ? null : expandKey, denyResponseText: '' }); }}
                      >
                        <i className={'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-chevron-down') + ' tw-mr-1'} />
                        {isExpanded ? 'Collapse' : 'Review'}
                      </button>
                      <button
                        className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                        style={{ backgroundColor: '#ECFDF5', color: '#065F46' }}
                        onClick={function() {
                          self.props.onConfirm({
                            type: 'approveAppeal',
                            userId: appeal.userId,
                            strikeId: appeal.strikeId,
                            userName: appeal.userName,
                            strikeReason: appeal.strikeReason,
                          });
                        }}
                      >
                        <i className="fa fa-check tw-mr-1" />Approve
                      </button>
                      <button
                        className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                        style={{ backgroundColor: '#EFF6FF', color: '#1D4ED8' }}
                        onClick={function() { self.props.onOpenUserModal(appeal.userId); }}
                      >
                        <i className="fa fa-user tw-mr-1" />View User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {isExpanded && (
                <div className="tw-bg-[#fafafa] dark:tw-bg-[#111] tw-px-5 tw-py-4" style={{ borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                  <div className="tw-space-y-4">
                    {/* Strike details */}
                    <div>
                      <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-2">Strike Details</h4>
                      <div className="tw-rounded-lg tw-p-3 tw-border tw-border-[#eee] dark:tw-border-[#222]" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff' }}>
                        <p className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-font-semibold">{appeal.strikeReason}</p>
                        {appeal.strikeDetails && <p className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-m-0 tw-mt-1">{appeal.strikeDetails}</p>}
                        <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-1">Issued: {appeal.strikeDate ? formatDate(appeal.strikeDate) : 'N/A'}</p>
                      </div>
                    </div>
                    {/* Appeal reason */}
                    <div>
                      <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-2">User's Appeal Reason</h4>
                      <div className="tw-rounded-lg tw-p-3 tw-border tw-border-[#eee] dark:tw-border-[#222]" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', borderLeft: '3px solid #6366f1' }}>
                        <p className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">{appeal.appealReason}</p>
                      </div>
                    </div>
                    {/* Deny with response */}
                    <div>
                      <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-2">Deny with Response</h4>
                      <textarea
                        className="tw-w-full tw-rounded-lg tw-text-[#1a1a1a] dark:tw-text-white tw-text-sm tw-p-3 tw-resize-none"
                        style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#ddd'), outline: 'none' }}
                        rows="3"
                        placeholder="Explain why the appeal is being denied (optional)..."
                        value={self.state.denyResponseText}
                        onChange={function(e) { self.setState({ denyResponseText: e.target.value }); }}
                      />
                      <div className="tw-flex tw-gap-2 tw-mt-2">
                        <button
                          className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border-0 tw-cursor-pointer tw-text-white hover:tw-opacity-90"
                          style={{ backgroundColor: '#EF4444' }}
                          onClick={function() {
                            self.props.onConfirm({
                              type: 'denyAppeal',
                              userId: appeal.userId,
                              strikeId: appeal.strikeId,
                              userName: appeal.userName,
                              strikeReason: appeal.strikeReason,
                              denyResponse: self.state.denyResponseText,
                            });
                          }}
                        >
                          <i className="fa fa-times tw-mr-1" />Deny Appeal
                        </button>
                        <button
                          className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                          style={{ backgroundColor: '#ECFDF5', color: '#065F46' }}
                          onClick={function() {
                            self.props.onConfirm({
                              type: 'approveAppeal',
                              userId: appeal.userId,
                              strikeId: appeal.strikeId,
                              userName: appeal.userName,
                              strikeReason: appeal.strikeReason,
                            });
                          }}
                        >
                          <i className="fa fa-check tw-mr-1" />Approve Instead
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default AdminStrikeAppeals;
